import { render } from "./Risposta.vue?vue&type=template&id=198010a9"
import script from "./Risposta.vue?vue&type=script&lang=js"
export * from "./Risposta.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__